const EURO_FORMATTER = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

const EURO_AMOUNT_PATTERN = /^\d+(\.\d{1,2})?$/;

/** 49990 → "499,90 €" */
export const formatCents = (cents: number): string => EURO_FORMATTER.format(cents / 100);

/** 49990 → "499,90" (value for an editable input) */
export const centsToEuroInput = (cents: number): string => (cents / 100).toFixed(2).replace('.', ',');

/**
 * "499,90" | "499.90" | "1.499,90 €" → integer cents, or null if the input is not a valid amount.
 * With a comma present, dots are treated as thousands separators.
 */
export const parseEuroInputToCents = (input: string): number | null => {
  const compact = input.replace(/[\s€]/g, '');
  const normalized = compact.includes(',') ? compact.replace(/\./g, '').replace(',', '.') : compact;
  if (!EURO_AMOUNT_PATTERN.test(normalized)) return null;
  return Math.round(Number(normalized) * 100);
};
